import React, { useEffect, useState, useRef } from "react";
import Link from "@pages/EverGreen/Components/Link";
import { Card } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { useHistory } from "react-router-dom";
import { SHIELD_STARTER_DECLARATION_LINK } from "@static/staticConstents";
import { SCREEN_SIZE } from "@static/screen-size";
import MainContainer from "@pages/EverGreen/Components/Container";
import { EverGreenStyle } from "@utils/Style/everGreen";
import Accordion from "@components/_Revamp/Accordion";
import { css } from "@linaria/core";
import { Text } from "@components/_Shared/Text";
import Bullet from "@pages/EverGreen/Components/Bullet";
import Modal from "@components/_Revamp/Modal";
import { updateDeclarationAcceptance } from "@redux/slices/EVER_GREEN/step3Slice";
import { getBaseURL } from "@api/index";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

const Header = styled.div<{ marginTop?: string }>`
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: ${EverGreenStyle.colors.grey[500]};
  font-size: 18px;
  margin-top: 0;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: ${EverGreenStyle.fontSize.smallTitle}px;
    margin-top: ${(prop) => prop.marginTop || "24"}px;
  }
`;

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;

const Description = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 140%;
  text-align: center;
  margin: 16px auto 32px auto;
  letter-spacing: 0.015em;
  color: #8a8988;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: ${EverGreenStyle.fontSize.description}px;
  }
`;

const ModalDescription = styled.div`
  font-style: normal;
  max-width: 588px;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  margin-top: 16px;
  letter-spacing: 0.015em;
  font-weight: 600;
  color: #8a8988;
`;

const ListComponent = styled.ul`
  li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: ${EverGreenStyle.colors.grey[500]};
    a {
      font-size: 14px;
    }
  }
  li:not(:first-child) {
    margin-top: 24px;
  }
`;

const CustomButton = styled.button<{ filled: boolean }>`
  border: none;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  height: 52px;
  background: ${(prop) =>
    prop.filled ? EverGreenStyle.colors.primary : EverGreenStyle.colors.white};
  align-items: center;
  text-align: center;
  transition: all 0.2s linear;
  color: ${(prop) =>
    prop.filled ? EverGreenStyle.colors.white : EverGreenStyle.colors.primary};
  cursor: pointer;
  border: 1px solid ${EverGreenStyle.colors.primary};
  border-radius: 100px;
  max-width: 295px;
  width: 100%;
  @media (hover: hover) {
    &:hover {
      background: ${EverGreenStyle.colors.primary};
      color: ${EverGreenStyle.colors.white};
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 48px 0;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 56px 0 0 0;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const importantNotes = [
  "A life policy is not a savings account or deposit;",
  "You may not get back the premiums paid (partially or in full) if you terminate or surrender the policy early;",
  "There is a 14-day free-look period;",
  "You can request the Financial Adviser Representative to explain the product features;",
  "You may wish to separately seek advice on suitability of the life policy; and",
  "In the event that you choose not to seek advice on the suitability of the life policy, you should consider if the life policy is suitable for your financial circumstances and needs.",
];

const container_default_css = css`
  margin-bottom: 130px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  color: #434343;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-left: 12px;
  @media screen and (min-width: 512px) {
    width: unset;
    font-size: 16px;
  }
`;

const accordionArgs = {
  title: "Important Notes:",
  theme: EverGreenStyle,
  className: container_default_css,
  titleClassName: title_default_css,
  headerPadding: "24px 24px 24px 0",
  titleFontSize: 14,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
  headerBackgroundColor: "#F4F6F9",
  showHeaderBackground: true,
};

function DocumentReview() {
  const history = useHistory();
  // const isChild = WhomTobuy === "child" ? true : false;
  // const [isJuvinal, setIsJuvinal] = useState(false);
  const dispatch = useAvivaDispatch();
  const [isShowModal, setIsShowModal] = useState(false);
  const DeclarationRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const fileName = useAvivaSelector(
    (s) => s.everGreenStep3.declarationResponse.policyIllustration
  );
  const everGreenStep2 = useAvivaSelector((state) => state.everGreenStep2);
  const everGreenStep3 = useAvivaSelector((state) => state.everGreenStep3);
  const campaignData = useAvivaSelector(state=>state.loading.campaignDetail)

  const customerId = everGreenStep2.myInfo.customerId;

  const isPepNotDone = useAvivaSelector(
    (state) => state.everGreenStep3.PEP.isPEP === null
  );

    //AA on load
    useEffect(()=>{
  if (isPepNotDone) return;

      trackOnLoad()
    },[])

  if (isPepNotDone) {
    history.push(ROUTE_PATH.EVER_GREEN_PEP);
    return null;
  }

  return (
    <>
      <div ref={DeclarationRef}>
        <MainContainer step={3} backButtonPath={ROUTE_PATH.EVER_GREEN_PEP}>
          <Header>Review documents and declaration</Header>
          <Description>
            Please ensure that you have clicked on the links and read all
            documents fully before making your declaration.
          </Description>
          <Card padding="0" marginTop="0" opacityValue="uset">
            <Card
              padding={"24px 64px"}
              opacityValue="uset"
              backgroundColor="none"
              marginTop="0"
            >
              <ListComponent>
                <li>
                  I have downloaded, read and understood the contents in the{" "}
                  <Link
                    text="Cover Page & Policy Illustration"
                    target="_blank"
                    rel="noopener noreferrer"
                    url={`${getBaseURL()}/ever-green/doc/policy-illustration/${fileName}`}
                  />{" "}
                  and{" "}
                  <Link
                    text="Product Summary"
                    target="_blank"
                    rel="noopener noreferrer"
                    url={`${getBaseURL()}/ever-green/doc/static/${customerId}/product-summary.pdf`}
                  />
                  .
                </li>
                <li>
                  I have downloaded, fully read and understood the{" "}
                  <Link
                    text="Policy Terms
                    & Conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    url={`${getBaseURL()}/ever-green/doc/static/${customerId}/policy-terms-conditions.pdf`}
                  />
                  .
                </li>
                <li>
                  I have read and agreed to the statements described in the{" "}
                  <Link
                    text="Declaration Document"
                    target="_blank"
                    rel="noopener noreferrer"
                    url={`${getBaseURL()}/ever-green/doc/static/${customerId}/declarations-document.pdf`}
                  />
                  .
                </li>
                <li>
                  I have reviewed all existing life insurance policies that I
                  own, or am in the process of applying for.
                </li>
                <li>
                  I have declared my current financial situation such as my
                  income in this application.
                </li>
                <li>
                  I have completed and disclosed fully and truthfully all the
                  information requested for in this application.
                </li>
                <li>
                  I understand that any misrepresentation or concealment of
                  facts shall render the policy to be issued and any other
                  policy which I have with Singlife to which the information
                  applies null and void
                </li>
                <li>
                  I am purchasing this plan without any advice from a financial
                  adviser representative and I take responsibility to ensure
                  that this plan suits my needs
                </li>
                <li>
                I understand that I will receive my policy, any endorsements and communications electronically once they are ready. I understand that I may log on to MySinglife to opt for my preferred document option and may switch between e-documents and printed documents.
                </li>

                {/* TODO : Age calculate to add the point */}
                {/* {isJuvinal && (
                  <li>
                    I am between 17 to 21 Age Next Birthday and Singlife will
                    request for my parent’s approval for my application.
                  </li>
                )} */}
              </ListComponent>
            </Card>
          </Card>
          <ButtonContainer>
            <CustomButton
              filled={false}
              onClick={() => {
                dispatch(updateDeclarationAcceptance(false));
                setIsShowModal(true);
              }}
            >
              I do not agree
            </CustomButton>
            <CustomButton
              filled={true}
              onClick={() => {
                // TODO: navigate to review payment page
                dispatch(updateDeclarationAcceptance(true));
                if(campaignData?.product === "DIGITALSAVER"){
                  history.push(ROUTE_PATH.EVER_GREEN_REVIEW)
                  return;
                }
                if (everGreenStep3.financialAdviserLink && everGreenStep3.financialAdviser.autoAssignAgent === "own-adviser") {
                  history.push(ROUTE_PATH.EVER_GREEN_ARC);
                } else {
                  history.push(ROUTE_PATH.EVER_GREEN_FINANCIAL_ADVISER);
                }
              }}
            >
              Agree to all
            </CustomButton>
          </ButtonContainer>
          <Accordion {...accordionArgs}>
            <div style={{ paddingBottom: "20px", paddingTop: "20px" }}>
              {importantNotes.map((note: string, index: number) => (
                <Bullet key={`${index}`} fontSize={14}>
                  <Text variant="base" fontSize="14px">
                    {note}
                  </Text>
                </Bullet>
              ))}
            </div>
          </Accordion>
        </MainContainer>
      </div>
      <Modal
        onClose={() => {
          setIsShowModal(false);
        }}
        show={isShowModal}
        colseBtnColor={EverGreenStyle.colors.primary}
        className={modalPadding}
      >
        <>
          <Header marginTop={"0"}>Need help with your declaration?</Header>
          <ModalDescription>
            Contact us if you have any concerns or need help with any part of
            the declaration.
          </ModalDescription>
          <ModalButtonContainer>
            <CustomButton
              filled={false}
              onClick={() => {
                setIsShowModal(false);
                history.push(ROUTE_PATH.EVER_GREEN_GET_STARTED);
              }}
            >
              Back to home
            </CustomButton>
            <CustomButton
              filled={true}
              onClick={() => {
                // dispatch(updateDeclaration(true));
                history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS);
              }}
            >
              Contact us{" "}
            </CustomButton>
          </ModalButtonContainer>
        </>
      </Modal>
      <div ref={SpacerRef}></div>
    </>
  );
}
export default DocumentReview;
